module.exports = __webpack_public_path__ + "img/faq-img.257f41f5.png";